import axiosBackend from '../axiosBackend';

export async function getCommunityMembers(params) {
  // console.log('getCommunityMembers (params): ', params);
  try {
    const response = await axiosBackend.get('/communityMembers', { params });
    // console.log('getCommunityMembers (response): ', response);

    // const items = response.data.data.length ? response.data.data.map((i) => {
    //   const {
    //     avatarURL, headline, name, surname, relationsCount, status,
    //   } = i;
    //   return {
    //     avatarURL, headline, name, surname, relationsCount, status,
    //   };
    // }) : [];
    response.data.data[0].status = 2
    const items = response.data.data.length ? response.data.data : [];

    const meta = response.data.meta
      ? { ...response.data.meta, offset: response.data.offset } : {};

    return {
      // data: {
      items,
      meta,
      // offset: response.data.data.offset ? response.data.data.offset : 0
      // }
    };
  } catch (error) {
    return error.response ? error.response : error;
  }
}

export default {
  getCommunityMembers,
};
